export default __webpack_public_path__ + "static/media/autos.a6145460.jpg";